import type React from 'react';
import styled, { useTheme } from 'styled-components';
import { useIntl } from 'react-intl';

import Typography from 'app/ui/components/atoms/typography';

import SlideWrapper from 'app/ui/components/atoms/slides/slide-wrapper';
import SlideHeader from 'app/ui/components/atoms/slides/header';
import TitleWrapper from 'app/ui/components/atoms/slides/title-wrapper';
import {
  FooterWrapper,
  LogosWrapper,
  LargeHyroxLogo,
  LargePoweredByFiit,
  LessonTitle,
} from 'app/ui/components/atoms/slides/slide-footer';

type LessonSlideWrapperProps = {
  lessonTitle: string;
  slideIndex: number;
  totalSlides: number;
  isPresenterView?: boolean;
  children: React.ReactNode;
  isOverviewMode?: boolean;
};

const CoachViewText = styled(Typography)`
  text-transform: uppercase;
`;

const LessonSlideWrapper: React.FC<LessonSlideWrapperProps> = ({
  lessonTitle,
  slideIndex,
  totalSlides,
  isPresenterView,
  children,
  isOverviewMode = false,
}) => {
  const theme = useTheme();
  const intl = useIntl();

  const coachView = intl.formatMessage({ id: 'whiteboard.coachView' });

  return (
    <SlideWrapper $isPresenterView={isPresenterView}>
      {isPresenterView && (
        <SlideHeader data-testid="lesson-slide-header">
          <TitleWrapper data-testid="lesson-slide-title">
            <Typography variant="h2" color={theme.colors.white}>
              {lessonTitle}
            </Typography>
            {!isOverviewMode && (
              <Typography variant="h4" color={theme.colors.white}>
                {`${slideIndex}/${totalSlides}`}
              </Typography>
            )}
          </TitleWrapper>
          {isOverviewMode && (
            <CoachViewText variant="h3" color={theme.colors.devilsGray}>
              {coachView}
            </CoachViewText>
          )}
        </SlideHeader>
      )}

      {children}

      <FooterWrapper>
        {!isPresenterView && (
          <TitleWrapper data-testid="lesson-slide-title">
            <LessonTitle variant="h4" color={theme.colors.devilsGray}>
              {lessonTitle}
            </LessonTitle>
            {!isOverviewMode && (
              <Typography variant="h4" color={theme.colors.devilsGray}>
                {`${slideIndex}/${totalSlides}`}
              </Typography>
            )}
          </TitleWrapper>
        )}
        <LogosWrapper $isPresenterView={isPresenterView}>
          <LargeHyroxLogo />
          <LargePoweredByFiit />
        </LogosWrapper>
      </FooterWrapper>
    </SlideWrapper>
  );
};

export default LessonSlideWrapper;
